import Joi from "joi";

const validation = Joi.object({
  dni: Joi.string().trim().required(),
});

export default validation;
